// @flow
import React, { Component } from "react";
import { connect } from "react-redux";

import ImageThumbnail from "./ImageThumbnail";

class Enrolments extends Component<*> {
  constructor(props) {
    super(props);
  }

  render(): React$Element<*> {
    const myEnrolments = this.props.db.enrolments;
    const groupList = myEnrolments && myEnrolments.map((enrolment, i) => {
      return (
        <ImageThumbnail
          enrolment_uid={enrolment.enrolment_uid}
          img={enrolment.face_url}
          key={enrolment.enrolment_uid}
        />
      );
    });

    return (
      <div>
        {groupList}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return { db: state.forensic.db };
};

export default connect(mapStateToProps, null)(Enrolments);


// WEBPACK FOOTER //
// ./src/conference/component/Enrolments.js